import React, { useRef } from "react";
import {
  CloudArrowUp,
  FileText,
  DownloadSimple,
  Trash,
} from "@phosphor-icons/react";

export default function AttachmentsTab({
  attachments,
  onUpload,
  onDownload,
  onDelete,
}) {
  const fileInputRef = useRef(null);
  return (
    <div className="bg-white border border-slate-200 rounded-lg">
      <div className="px-6 py-4 border-b border-slate-200 flex items-center justify-between">
        <h3 className="font-heading font-semibold text-slate-900">Attachments</h3>
        <input
          ref={fileInputRef}
          type="file"
          className="hidden"
          onChange={onUpload}
          data-testid="attachment-file-input"
        />
        <button
          onClick={() => fileInputRef.current?.click()}
          className="inline-flex items-center gap-2 px-3 h-9 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700"
          data-testid="upload-attachment-button"
        >
          <CloudArrowUp size={16} /> Upload File
        </button>
      </div>
      {attachments.length === 0 ? (
        <div className="px-6 py-12 text-center text-sm text-slate-500">
          No attachments yet.
        </div>
      ) : (
        <ul className="divide-y divide-slate-100">
          {attachments.map((a) => (
            <li
              key={a.id}
              className="px-6 py-3 flex items-center justify-between gap-4"
              data-testid={`attachment-row-${a.id}`}
            >
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-9 h-9 bg-slate-100 rounded-md flex items-center justify-center text-slate-500">
                  <FileText size={18} />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-slate-900 truncate">
                    {a.file_name}
                  </div>
                  <div className="text-xs text-slate-500">
                    {(a.size / 1024).toFixed(1)} KB ·{" "}
                    {new Date(a.uploaded_at).toLocaleDateString()}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => onDownload(a)}
                  className="p-2 rounded-md hover:bg-slate-100 text-slate-600"
                  data-testid={`download-attachment-${a.id}`}
                >
                  <DownloadSimple size={16} />
                </button>
                <button
                  onClick={() => onDelete(a.id)}
                  className="p-2 rounded-md hover:bg-red-50 text-red-500"
                  data-testid={`delete-attachment-${a.id}`}
                >
                  <Trash size={16} />
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
